module.exports = __webpack_public_path__ + "static/img/serve2.9d589dd5.png";